import * as React from "react";
const SvgInfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#313131"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12ZM7 10.6V7"
    />
    <path
      stroke="#313131"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 4.6h.007"
    />
  </svg>
);
export default SvgInfoIcon;
